import { render, staticRenderFns } from "./DuplicateConfirmDialog.vue?vue&type=template&id=3b97d8a0&"
import script from "./DuplicateConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./DuplicateConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports